<template>
  <div class="toast-container" v-if="visible">
    <div class="toast" :class="`toast-${type}`">
      {{ message }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps({
  message: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'error'
  },
  duration: {
    type: Number,
    default: 3000
  },
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible']);

// 监听 visible 属性变化，如果为 true，则在指定时间后自动关闭
watch(() => props.visible, (newValue) => {
  if (newValue && props.duration > 0) {
    setTimeout(() => {
      emit('update:visible', false);
    }, props.duration);
  }
});
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  max-width: 350px;
  width: 100%;
  display: flex;
  justify-content: center;
  transition: all 0.3s ease;
}

.toast {
  padding: 15px 20px;
  border-radius: 4px;
  margin-bottom: 10px;
  color: white;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease forwards;
}

.toast-error {
  background-color: #f56c6c;
}

.toast-success {
  background-color: #67c23a;
}

.toast-warning {
  background-color: #e6a23c;
}

@keyframes slideIn {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(-100%);
    opacity: 0;
  }
}
</style>
